import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import globals from '../../../globals/communityGlobals';

import timeSlotPropType from '../../../propTypes/entities/timeSlot';

// If this is supposed to be an actual tooltip,
// perhaps you could use the one in components/common/Tooltip

const formatHour = date =>
  moment(date)
    .utcOffset(0, true)
    .format(globals.timeFormats.short);

const toolTip = ({ timeSlots }) => (
  <div>
    {timeSlots.map(({ id, from, to, name }) => (
      <span key={`historic-visits-timeSlots${id}`} className="historic-visits-timeSlots">
        {`${name ? `${name}: ` : ''}${formatHour(from) + (from === to ? '' : ` - ${formatHour(to)}`)}`}
      </span>
    ))}
  </div>
);

toolTip.defaultProps = {
  timeSlots: [],
};

toolTip.propTypes = {
  timeSlots: PropTypes.arrayOf(timeSlotPropType),
};

export default toolTip;
